<div class="ag-overlay-loading-center background-container" role="presentation">
    <cv-loader class="cxone-loader" [size]="'large'" [loaderType]="'cxone'" [overlay]="true" ></cv-loader>
</div>